import React, { useState } from "react";
import AppLayout from "@/Layouts/AppLayout";
import { useTitle } from "@/Utilities/Hooks";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { Users } from "@/Icons";
import { Tab, Tabs } from "@/Components/Tabs";
import { Dialog } from "@/Components";
import { LabeledInput } from "@/Components/Form";
import { Inertia } from "@inertiajs/inertia";
import { usePage } from "@inertiajs/inertia-react";
import { toast } from "react-toastify";
import SuperUserRow from "@/Pages/Superuser/Users/Partials/SuperUserRow";

export default function ManageSuperUsers({ users }) {
  useTitle("Super users");

  return (
    <Tabs items={["All super users"]}>
      <Tab>
        {users?.data?.map((user) => (
          <SuperUserRow key={user.id} user={user} />
        ))}
      </Tab>
    </Tabs>
  );
}

ManageSuperUsers.layout = (page) => {
  return (
    <AppLayout>
      <OrganizationLayout
        header="Super users"
        icon={
          <LayoutIcon>
            <Users size={40} className="text-black" />
          </LayoutIcon>
        }
        action={{
          label: "New super user",
          callback: () => Inertia.visit(route("admin.users.create")),
        }}
        byline="Manage all yours with administrative privilege"
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
